import {
  SET_HEADER_DROPDOWN,
  SET_HEADER_STICKY_CONTENT_OFFSET,
} from "./actions"

const INITIAL_STATE = {
  dropdown: "",
  stickyContentOffset: 0,
}

export default function header(state = INITIAL_STATE, action) {
  let newState = Object.assign({}, state)
  switch (action.type) {
    case SET_HEADER_DROPDOWN:
      newState.dropdown = action.dropdownName
      return newState
    case SET_HEADER_STICKY_CONTENT_OFFSET:
      newState.stickyContentOffset = action.offset
      return newState
    default:
      return state
  }
}
